import React, { useState, useEffect, useContext } from 'react';
import './ExpandingCardsDesign.css';
import { vibhagsData } from '../vibhagsData';
import { LanguageContext } from '../../../context/LanguageContext';
import ScrollAnimation from '../../ScrollAnimations';

const ExpandingCardsDesign = () => {
  const [expandedCard, setExpandedCard] = useState(null);
  const { lang } = useContext(LanguageContext);

  useEffect(() => {
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  useEffect(() => {
    if (expandedCard) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [expandedCard]);

  const handleCardClick = (vibhagId) => {
    setExpandedCard(vibhagId);
  };

  const handleCloseModal = () => {
    setExpandedCard(null);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleCloseModal();
    }
  };

  return (
    <div className="expanding-cards-design">
      {/* Vibhags Grid */}
      <div className="vibhags-grid">
        {vibhagsData.map((vibhag, index) => (
          <ScrollAnimation 
            key={vibhag.id}
            animation="fade-up" 
            delay={index * 100}
          >
            <div
              className="vibhag-card"
              style={{ '--vibhag-color': vibhag.color }}
              onClick={() => handleCardClick(vibhag.id)}
            >
              <div className="card-content">
                <div className="vibhag-icon-large">
                  <img src={vibhag.icon} alt={vibhag.name.english} />
                </div>
                <h3 className="vibhag-name-marathi">{vibhag.name.marathi}</h3>
                <h4 className="vibhag-name-english">{vibhag.name.english}</h4>
                <div className="expand-hint">
                  <span>View more</span>
                </div>
              </div>
            </div>
          </ScrollAnimation>
        ))}
      </div>

      {/* Modal Overlay */}
      {expandedCard && (
        <div className="modal-overlay" onClick={handleBackdropClick}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-icon">
                <img 
                  src={vibhagsData.find(v => v.id === expandedCard)?.icon} 
                  alt={vibhagsData.find(v => v.id === expandedCard)?.name.english} 
                />
              </div>
              <button 
                className="modal-close-btn"
                onClick={handleCloseModal}
                title="Close"
                aria-label="Close modal"
                style={{
                  background: '#2c5282',
                  color: 'white',
                  border: '2px solid white',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  fontSize: '1.4rem',
                  fontWeight: 'bold',
                  opacity: 1,
                  visibility: 'visible'
                }}
              >
                ✕
              </button>
            </div>
            
            <div className="modal-body">
              <h2 className="modal-title-marathi">
                {vibhagsData.find(v => v.id === expandedCard)?.name.marathi}
              </h2>
              <h3 className="modal-title-english">
                {vibhagsData.find(v => v.id === expandedCard)?.name.english}
              </h3>
              
              <div className="modal-description">
                {(() => {
                  const currentVibhag = vibhagsData.find(v => v.id === expandedCard);
                  const description = lang === 'mr' ? currentVibhag?.descriptionMarathi : currentVibhag?.description;
                  
                  return (
                    <>
                      {description?.title && (
                        <p className="description-title">
                          {description.title}
                        </p>
                      )}
                      {description?.points && 
                       description.points.map((point, index) => (
                        <p key={index} className="description-line">{point}</p>
                      ))}
                      {description?.special && (
                        <p className="description-special">
                          {description.special}
                        </p>
                      )}
                    </>
                  );
                })()}
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default ExpandingCardsDesign;